import Nullstack from 'nullstack';
export default function IconAlarmSnooze({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-alarm-snooze",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "13",
    r: "7"
  }), "   ", Nullstack.element("path", {
    d: "M10 11h4l-4 4h4"
  }), "   ", Nullstack.element("path", {
    d: "M7 4l-2.75 2"
  }), "   ", Nullstack.element("path", {
    d: "M17 4l2.75 2"
  }), " ");
}